import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import NwContent from 'components/Layout/NwContent';
import NwBookLayoutMobile from 'components/Layout/NwBookLayoutMobile';
import PlaylistMobile from 'components/Playlist/PlaylistMobile';
import ModelInfo from './ModelInfo';
import { BookLayoutContext } from 'contexts/BookLayoutContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import PlaylistsNavMobileNoScroll from 'components/Model/PlaylistsNavMobileNoScroll';

const ModelWrapper = styled.div`
    position: relative;
    margin-bottom: 4rem;
    .model-playlists-wrapper {
        min-height: 120vh;
        padding-top: 1rem;
        .model-playlist-wrapper {
            padding: 1rem 0 0 0;
            position: relative;
            .model-playlist-anchor {
                position: absolute;
                top: 0;
                left: 0;
            }
        }
    }

    .model-info-container {
        padding-top: .75rem;
        width: 100%;

        .model-header-first-line {
            margin-bottom: 1rem;
            h1 {
                font-size: 1.6rem;
            }
        }

        .model-header-second-line {
            padding: .5rem 0;
            /* border-bottom: 1px solid ${props => props.theme.BorderColor}; */
            /* border-top: 1px solid ${props => props.theme.BorderColor}; */
            margin: .5rem 0 .5rem 0;

            .model-socials-wrapper {
                width: 100%;
                margin-top: 0;
                justify-content: flex-start;
                gap: 2rem;
            }
        }

        .model-features {
            .model-feature {
                line-height: 1.5em;
                font-size: 1rem;
            }
        }

        .model-additional-info {
            .model-birthdate {
                font-size: 1rem;
            }
            .model-age {
                font-size: 1rem;
            }
            .model-customfield {
                font-size: 1rem;
            }
        }

    }

    .model-note {
        padding: 1rem .5rem 0 .3rem;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        .model-note-icon {
            padding: 0 .75rem 0 0;
            font-size: 1rem;
        }

        p {
            font-size: .9rem;
            line-height: 1.2em;
            margin: 0;
        }
    }
`


const ModelMobile = ({ models }) => {

    const { modelId } = useParams()
    const [model, setModel] = useState()
    const [modelPlaylists, setModelPlaylists] = useState([])
    const [activePlaylist, setActivePlaylist] = useState(0)

    const { headerHeight } = useContext(BookLayoutContext)

    //const [elRefs, setElRefs] = React.useState([])
    //let scrollHandler = null

    const handleChangeModel = modelId => {
        const model = models.find(model => model.ID === modelId);
        window.scrollTo(0, 0)
        setModelPlaylists(model.Playlists)
        setModel(model)
    };

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [activePlaylist])

    useEffect(() => {
        if (models.length > 0) {
            handleChangeModel(parseInt(modelId));
        }
    }, [models, modelId]);

    // useEffect(() => {
    //     if (model && model.Playlists.length) {
    //         setElRefs((elRefs) =>
    //             Array(model.Playlists.length)
    //                 .fill()
    //                 .map((_, i) => elRefs[i] || createRef()),
    //         );
    //     }
    // }, [model]);

    // useEffect(() => {
    //     scrollHandler = () => {
    //         let activeindex = 0;
    //         if (elRefs.length > 1) {
    //             for (let i = 0; i < elRefs.length; i++) {
    //                 if (elRefs[i] && elRefs[i].current) {
    //                     const scroll = window.scrollTop + 200 //removed initial padding
    //                     const playlistoffset = elRefs[i].current.offsetTop
    //                     if (scroll > playlistoffset) {
    //                         activeindex = i;
    //                     }
    //                 } else {
    //                     activeindex = 0
    //                 }
    //             }
    //         }
    //         setActivePlaylist(activeindex)
    //     }

    //     if (elRefs.length > 1) {
    //         window.addEventListener('scroll', scrollHandler);
    //         return () => {
    //             window.removeEventListener('scroll', scrollHandler)
    //         }
    //     } else {
    //         setActivePlaylist(0)
    //     }
    // }, [elRefs]);

    return (
        <NwBookLayoutMobile>
            <div className="top-page-anchor" id="page-top"></div>
            <NwContent>
                {model &&
                    <ModelWrapper $headerHeight={`${headerHeight}px`}>
                        <div className="model-info-container">
                            <ModelInfo model={model} mobile />
                        </div>
                        {model.Note &&
                        <div className="model-note">
                            <div className="model-note-icon">
                                <FontAwesomeIcon icon={icon({ name: 'message-lines', family: 'sharp', style: 'light' })} />
                            </div>
                            <p>{model.Note}</p>
                        </div>
                        }
                        {modelPlaylists.length > 0 && //showing always
                            // changed to no scroll because the anchor is not working reliably
                            <PlaylistsNavMobileNoScroll
                                model={model}
                                activePlaylist={activePlaylist}
                                setActivePlaylist={setActivePlaylist}
                            />
                        }
                        <div className="model-playlists-wrapper" id="model-playlists-wrapper">
                            {/* show only active playlist, not using scroll because the anchor is not working reliably */}
                            <div className="model-playlist-wrapper">
                                <PlaylistMobile
                                    playlist={modelPlaylists[activePlaylist]}
                                    playlistIndex={activePlaylist}
                                />
                            </div>
                            {/* {modelPlaylists.map((playlist, index) => {
                                return (
                                    <div
                                        className="model-playlist-wrapper"
                                        ref={elRefs[index]}
                                        key={`playlist-${playlist.ID}`}
                                    >
                                        <PlaylistMobile
                                            playlist={playlist}
                                            playlistIndex={index}
                                        />
                                    </div>
                                )
                            })} */}
                        </div>
                    </ModelWrapper>
                }
            </NwContent>
        </NwBookLayoutMobile>
    );
};

export default ModelMobile;
